import React from 'react';

import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment } from '@material-ui/icons';

export default function ReadOther(props) {
  const { dataProduct } = props;

  return (
    <GridItem xs={12}>
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 style={{ color: 'black' }}>Datos adicionales</h4>
        </CardHeader>
        <CardBody>
          <h6>Comentario</h6>
          <p>{dataProduct.UserText || '...'}</p>
        </CardBody>
      </Card>
    </GridItem>
  );
}
